<template>
  <BillingLineItemCell :emphasized="emphasized">
    <slot></slot>
  </BillingLineItemCell>
</template>

<script>
import BillingLineItemCell from './BillingLineItemCell.vue';

export default {
  name: 'BillingLineItemValue',
  components: { BillingLineItemCell },
  props: {
    emphasized: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
